// const baseUrl = 'http://192.168.68.117:8080'; // 测试环境
// const baseUrl = 'http://10.226.145.2:8080'; // 后端 测试
// const login_baseUrl = 'http://192.168.68.117:8080'; // 后端
const baseUrl = "https://dpm.deppon.com:8881";

const address = {
  applyResources: baseUrl + '/dpm/dpm-management/question_insertAnswerExam.action',
  searchDpt: baseUrl + '/dpm/dpm-management/question_getHeadQuartersList.action',
  // loginUrl: baseUrl  + '/dpm/dpm/login_login.action',
  loginUrl: baseUrl  + '/dpm/dpm/login_login2.action',
  searchItems: baseUrl + '/dpm/dpm-management/question_answerListByTime.action',
  changeStatus: baseUrl + '/dpm/dpm-management/question_doCloseAnswerEx.action'
}

export default address;



// WEBPACK FOOTER //
// ./src/libs/address.js